export const Slider = function(dom) {
    const carouselSlides = Array.from(document.querySelectorAll(dom));
    if(carouselSlides.length == 0){
        return 0;
    }
    const btnPrev = document.querySelector('.prev');
    const btnNext = document.querySelector('.next');
    const dotsSlide = document.querySelector('.dots-container');
    let currentSlide = 0;

    const activeDot = function (slide) {
        let doms = Array.from(document.querySelectorAll('.dot'));
        doms.forEach(dot => dot.classList.remove('active'));
        document.querySelector(`.dot[data-slide="${slide}"]`).classList.add('active');
    };
    activeDot(currentSlide);

    const changeSlide = function (slides) {
        carouselSlides.forEach((slide, index) => (slide.style.transform = `translateX(${100 * (index - slides)}%)`));
    };
    changeSlide(currentSlide);

    if(btnNext){
        btnNext.addEventListener('click', function () {
            currentSlide++;
            if (carouselSlides.length - 1 < currentSlide) {
                currentSlide = 0;
            };
            changeSlide(currentSlide);
            activeDot(currentSlide);
        });
    }
    if(btnPrev){
        btnPrev.addEventListener('click', function () {
            currentSlide--;
            if (0 >= currentSlide) {
                currentSlide = 0;
            };
            changeSlide(currentSlide);
            activeDot(currentSlide);
        });
    }
    if(dotsSlide){
        dotsSlide.addEventListener('click', function (e) {
            let dom = e.target as HTMLTextAreaElement;
            if (dom.classList.contains('dot')) {
                const slide = dom.dataset.slide;
                changeSlide(slide);
                activeDot(slide);
            }
        });
    }
};